
// 文件类型
export const FILE_TYPE = {
    COVER: '1', //封面
    IMAGE: '2', //图片
    VIEDO: '3', //视频
}